<template>
  <tab-layout :full-width="true">
    <div slot="tabContent" class="bg-white rounded mb-4 p-3">
      <page-heading>Prize Money Summary</page-heading>

      <div v-if="loading" class="text-center py-5">Loading...</div>

      <template v-else-if="summary">
        <div class="prize-summary__draft mb-4">
          <h2 class="h4 m-0">{{ summary.draftName }}</h2>
          <div class="prize-summary__draft-total">
            Total prize money for draft: <strong>${{ summary.totalPrize.toFixed(2) }}</strong>
          </div>
        </div>

        <h3 class="h5 mb-3">Events</h3>

        <div
          v-for="event in summary.events"
          :key="event.id"
          class="prize-summary__event mb-3"
        >
          <div class="prize-summary__event-header">
            <div class="prize-summary__event-name">{{ event.name }}</div>
            <div class="prize-summary__event-total">
              Total: <strong>{{ event.totalPrize > 0 ? '$' + event.totalPrize.toFixed(2) : '$' }}</strong>
            </div>
          </div>

          <div v-if="event.rounds && event.rounds.length" class="prize-summary__rounds">
            <div
              v-for="round in event.rounds"
              :key="round.order"
              class="prize-summary__round"
            >
              <div class="prize-summary__round-title">
                {{ round.is_final ? 'FINAL ROUND' : 'ROUND ' + round.order }}
              </div>
              <table class="prize-summary__table">
                <thead>
                  <tr>
                    <th>Place</th>
                    <th>$</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="place in round.places" :key="place.place">
                    <td>{{ place.place }}</td>
                    <td>{{ place.sum.toFixed(2) }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td><strong>TOTAL</strong></td>
                    <td><strong>{{ round.total.toFixed(2) }}</strong></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </template>
    </div>
  </tab-layout>
</template>

<script>
import { defineComponent, ref, computed, onMounted, getCurrentInstance } from '@vue/composition-api'
import TabLayout from '@/components/TabLayout'
import PageHeading from '@/components/PageHeading'
import calculatorsApi from '@/services/api/calculators'

export default defineComponent({
  name: 'PrizeSummaryView',
  components: { TabLayout, PageHeading },
  setup() {
    const vm = getCurrentInstance()
    const draftId = computed(() => vm.proxy.$route.params.draftId)
    const summary = ref(null)
    const loading = ref(false)

    async function fetchSummary() {
      loading.value = true
      try {
        const res = await calculatorsApi.getDraftPrizeSummary(draftId.value)
        summary.value = res.data.data
      } catch (_) {
        // http.js handles toast
      } finally {
        loading.value = false
      }
    }

    onMounted(fetchSummary)

    return { summary, loading }
  }
})
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variables';
.prize-summary__draft {
  background: #f8d7da;
  border-radius: 4px;
  padding: 1rem 1.25rem;
  display: inline-block;
  min-width: 260px;
  font-weight: 700;
  font-size: 1.25rem;
}

.prize-summary__draft-total {
  margin-top: 0.25rem;
  font-size: 0.95rem;
}

.prize-summary__event {
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.prize-summary__event-header {
  padding: 0.6rem 1rem;
  border-bottom: 1px solid #dee2e6;
  background: #f8f9fa;
}

.prize-summary__event-name {
  font-weight: 400;
  font-size: 1.1rem;
  color: $primary;
}

.prize-summary__event-total {
  font-weight: 700;
  color: #000;
}

.prize-summary__rounds {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem;
}

.prize-summary__round-title {
  text-align: center;
  font-weight: 600;
  font-size: 0.85rem;
  background: #e9ecef;
  padding: 0.3rem;
  margin-bottom: 0.25rem;
  color: $primary;
}

.prize-summary__table {
  width: 180px;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.prize-summary__table th,
.prize-summary__table td {
  border: 1px solid #dee2e6;
  padding: 0.25rem 0.5rem;
  text-align: center;
}

.prize-summary__table tfoot td {
  background: #f8f9fa;
}
</style>



// WEBPACK FOOTER //
// src/views/Draws/PrizeSummary/PrizeSummaryView.vue